import React, { useMemo, useState } from 'react';
import { Button, Card, Col, Container, Offcanvas, Row } from 'react-bootstrap-5';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

import Tasks from './tasks';
import NotesCard from './notes';
import Overview from './overview';
import ActivitySection from './activity_section';
import ActivityHistoryCard from '../contacts/activity_history_card';
import { PROPERTY_MODEL } from '../../constants';
import {
  selectCallConsoleConnectPropertyId,
  selectCallConsolePropertyId,
  selectCallListId
} from '../store/selectors/call_console';
import type { CallTemplate } from 'bundles/connect/types';

type CallListItemProps = {
  callTemplates: CallTemplate[];
}

export default function CallListItem({ callTemplates }: CallListItemProps) {
  const [showProperty, setShowProperty] = useState(false);
  const headerButtonContainerTablet = useMemo(() => document.getElementById('js-header-portal-tablet'), []);
  const headerButtonContainerMobile = useMemo(() => document.getElementById('js-header-portal-mobile'), []);
  const callListId = useSelector(selectCallListId);
  const connectPropertyId = useSelector(selectCallConsoleConnectPropertyId);
  const insightsPropertyId = useSelector(selectCallConsolePropertyId);

  const OVERVIEW_PROPS = {
    insightsPropertyId,
    inRethink: false
  };

  return (
    <>
      <Container fluid>
        {headerButtonContainerTablet && createPortal((
          <Button className="mt-1" variant="primary" onClick={() => setShowProperty(true)}>View Property</Button>
        ), headerButtonContainerTablet)}
        {headerButtonContainerMobile && createPortal((
          <Button className="w-100" variant="primary" onClick={() => setShowProperty(true)}>View Property</Button>
        ), headerButtonContainerMobile)}
        <Offcanvas
          className="property-offcanvas"
          enforceFocus={false}
          placement="end"
          show={showProperty}
          onHide={() => setShowProperty(false)}
        >
          <Offcanvas.Header className="d-md-none justify-content-end" closeButton />
          <Overview {...OVERVIEW_PROPS} />
        </Offcanvas>
        <Row className="g-3">
          <Col className="d-none d-xl-block" xl={5}>
            <Overview {...OVERVIEW_PROPS} />
          </Col>
          <Col>
            <Row className="g-3">
              <Col xs={12}>
                <ActivitySection
                  callListId={callListId}
                  callTemplates={callTemplates}
                  connectPropertyId={connectPropertyId}
                />
              </Col>
              <Col xs={12}>
                <Row className="g-3">
                  <Col xl={6}>
                    <Card>
                      <Card.Header>
                        <h5 className="fw-bolder mb-0">Activity History</h5>
                      </Card.Header>
                      <ActivityHistoryCard />
                    </Card>
                  </Col>
                  <Col className="d-flex flex-column gap-3" xl={6}>
                    <NotesCard
                      callListId={callListId}
                      recordId={connectPropertyId}
                      recordType={PROPERTY_MODEL}
                    />
                    <Tasks
                      callListId={callListId}
                      connectPropertyId={connectPropertyId}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
